export default {
  common: () => ({ type: 'PAGES/COMMON' }),
  fetch: slug => ({ type: 'PAGES/FETCH', slug }),
};